import { deviceId, draftAlreadySubmitted } from './shift-journal';
import { getActiveStore } from './scope';
import { accessTokenClaims } from './auth-session';

const locks = new Map();
const prefix = scope => `pos_hold_handoff:v1:${scope.tenant}:${scope.user}:${scope.store}:`;
const key = (scope, id) => prefix(scope) + id;
export const holdScope = (tenant, user, store) => ({ tenant, user, store });
function guard(scope) {
  const claims = accessTokenClaims(localStorage.getItem('pos_token'));
  if (getActiveStore() !== scope.store || claims?.sub !== scope.user || claims?.aud !== scope.tenant) {
    throw new Error('Akun/cabang berubah. Keranjang tetap tersimpan; kembali ke akun dan cabang asal.');
  }
}

export function readHeldDraft(scope, id) {
  const raw = localStorage.getItem(key(scope, id));
  if (!raw) return null;
  const saved = JSON.parse(raw);
  if (saved.version !== 1 || saved.source?.id !== id || !saved.source?.token) throw new Error('Cadangan antrian tidak terbaca. Jangan hapus data browser.');
  return saved;
}
function write(scope, id, value) {
  const text = JSON.stringify(value);
  localStorage.setItem(key(scope, id), text);
  if (localStorage.getItem(key(scope, id)) !== text) throw new Error('Cadangan antrian belum tersimpan.');
}

// Keep a browser lock for the entire active cart, not only the network request.
// It is automatically released when a tab closes. A second tab cannot replay it.
export async function lockHeldCart(scope, id) {
  const name = key(scope, id);
  if (locks.has(name)) return;
  if (!navigator.locks?.request) throw new Error('Gunakan Chrome terbaru melalui HTTPS untuk pengamanan antrian.');
  await new Promise((resolve, reject) => {
    navigator.locks.request(name, { ifAvailable: true }, async lock => {
      if (!lock) { reject(new Error('Keranjang masih terbuka di tab lain. Gunakan atau tutup tab asal dahulu.')); return; }
      await new Promise(release => { locks.set(name, release); resolve(); });
    }).catch(reject);
  });
}
export function releaseHeldLock(scope, id) {
  const name = key(scope, id), release = locks.get(name);
  locks.delete(name); release?.();
}
export function saveHeldDraft(scope, saved) {
  if (!saved?.draft?.holdSource) return;
  const source = saved.draft.holdSource;
  write(scope, source.id, { version: 1, source, saved });
}
export function clearHeldDraft(scope, id) {
  // Failure to remove must be reported; never silently replay an old snapshot.
  localStorage.removeItem(key(scope, id));
  releaseHeldLock(scope, id);
}
export async function recallHeldCart(api, scope, id) {
  guard(scope);
  await lockHeldCart(scope, id);
  try {
    const existing = readHeldDraft(scope, id);
    if (existing?.saved?.id && draftAlreadySubmitted(scope.tenant, scope.user, existing.saved.id)) {
      throw new Error('Keranjang sudah masuk jurnal pembayaran. Periksa sinkronisasi/Riwayat, jangan panggil ulang.');
    }
    const source = existing?.source || { id, token: crypto.randomUUID(), device_id: deviceId() };
    // Persist the retry capability BEFORE the request can consume the queue.
    if (!existing) write(scope, id, { version: 1, source });
    const { data } = await api.post(`/holds/${id}/recall`, { token: source.token, device_id: source.device_id }, { timeout: 20000, headers: { 'X-Store-Id': scope.store } });
    guard(scope);
    if (!data.hold_source || data.hold_source.token !== source.token) throw new Error('Server belum mendukung pemulihan aman. Keranjang tidak dibuka; hubungi admin.');
    return { data, saved: existing?.saved || null };
  } catch (error) {
    releaseHeldLock(scope, id);
    throw error;
  }
}
